/**
 * Defaults from docs/specs/frontend-architecture.md. Numbers that are shared with the API/worker
 * are mirrored from @lumen/shared where available (see src/lib/shared.ts).
 */
export const IS_MOCK = import.meta.env.VITE_MOCK === '1';
/**
 * API origin. Unset → the dev default; `/` or empty → same origin (the production nginx image proxies
 * `/api` and `/ws` to the api service, so the browser never crosses origins).
 */
export const API_ORIGIN = (import.meta.env.VITE_API_URL ?? 'http://localhost:4000').replace(/\/$/, '');
const SAME_ORIGIN = IS_MOCK || API_ORIGIN === '';
export const API_BASE = SAME_ORIGIN ? '/api/v1' : `${API_ORIGIN}/api/v1`;
export const WS_URL =
  import.meta.env.VITE_WS_URL ??
  (SAME_ORIGIN
    ? `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`
    : API_ORIGIN.replace(/^http/, 'ws') + '/ws');

// --- grid (§2) ---------------------------------------------------------------------------
export const GRID_GAP = 12;
export const GRID_FOOTER = 36;
export const CARD_WIDTH_MIN = 160;
export const CARD_WIDTH_MAX = 480;
export const CARD_WIDTH_DEFAULT = 240;
export const GRID_MAX_COLS = 12;
export const GRID_PAGE_SIZE = 200;
export const GRID_POOL_MAX = 400;
export const ASPECT_MIN = 0.2;
export const ASPECT_MAX = 5;
export const OVERSCAN_ABOVE = 0.5; // × viewportH
export const OVERSCAN_BELOW = 1.5; // × viewportH
export const PREFETCH_DISTANCE = 2; // × viewportH
export const SUBBOARD_VIRTUAL_THRESHOLD = 60;
export const LAYOUT_CACHE_SIZE = 4;

// --- upload (§3) --------------------------------------------------------------------------
// contract numbers come from @lumen/shared so web/api/worker cannot drift
export {
  MAX_CONCURRENT_FILES,
  MAX_PARTS_IN_FLIGHT,
  PART_MAX_ATTEMPTS as PART_RETRY_MAX,
  HASH_READ_CHUNK_BYTES as HASH_CHUNK_BYTES,
  SAMPLED_HASH_THRESHOLD_BYTES as SAMPLED_HASH_THRESHOLD,
  SAMPLED_HASH_HEAD_BYTES as SAMPLED_HASH_EDGE_BYTES,
  MAX_FILE_BYTES,
} from '@lumen/shared';
export const PREVIEW_MAX_IMAGE_BYTES = 50 * 1024 * 1024;
export const PREVIEW_LONG_EDGE = 512;
export const IDB_NAME = 'lumen-uploads';
export const IDB_VERSION = 1;
export const UPLOAD_ROW_TTL_MS = 7 * 24 * 3600_000;
export const UPLOAD_DONE_DISMISS_MS = 10_000;

// --- realtime (§4.6) ----------------------------------------------------------------------
export const WS_PING_INTERVAL_MS = 25_000;
export const WS_IDLE_TIMEOUT_MS = 60_000;
export const WS_UNSUB_GRACE_MS = 5_000;
export const WS_HIDDEN_CLOSE_MS = 5 * 60_000;
export const WS_PRESENCE_INTERVAL_MS = 15_000;
export const WS_BACKOFF_MAX_MS = 30_000;

// --- search (§5) --------------------------------------------------------------------------
export const SEARCH_PAGE_SIZE = 60;
export const SEARCH_DEBOUNCE_MS = 150;
export const SEARCH_HISTORY_MAX = 20;

// --- misc ---------------------------------------------------------------------------------
export const MEDIA_URL_STALE_MS = 50 * 60_000;
export const SIDEBAR_WIDTH = 272;
export const SIDEBAR_COLLAPSED_WIDTH = 56;
export const ANNOTATION_DEFAULT_STROKE_REL = 0.004;
export const RDP_EPSILON = 0.002;
export const PATH_MAX_POINTS = 2000;
